<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      :retain-focus="false"
      content-class="bottom-sheet min-height-auto"
  >
    <v-card>
      <v-card-title>
        도움말
        <v-spacer />
        <v-btn icon @click="sheetOpen(false)">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text ref="card">
        <div class="text-area" v-html="helpContent"></div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close'

export default {
  props:{
      helpContent:String,
  },
  data: () => ({
    sheet: false,
  }),
  watch: {
  },
  components: {
    Close,
  },
  methods: {
    sheetOpen(flag) {
      this.sheet = flag;
    },
  }
}
</script>
<style lang="scss" scoped>
//.text-area {
//  min-height: 210px;
//  background: #F4F4F4;
//  //overflow-y: auto;
//  font-size: 14px;
//  color: #101010;
//  border-radius: 6px;
//  padding: 16px;
//}
</style>
